
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import vuescroll from 'vuescroll'
import Error from '@/components/error'
import { mapState } from 'vuex'
export default {
name: 'pay',
props: [],
components: {
XHeader,
Swiper,
SwiperItem,
Grid,
GridItem,
XButton,
Tab,
TabItem,
'scroller': vuescroll,
Error
},
data () {
return {
title: this.$store.state.currentProcedureInfo.name,
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},




























swiper: {
isDots: false,
aspectRatio: 0.35
},
isFixed: false,
pendingList: [],
index: 0,
billType: [
{
name: '全部'
},
{
name: '待缴'
},
{
name: '已缴'
}
],
billList: [],
errorMsg: {
type: 'null',
content: '当前分类无账单明细'
},
thirdUrl: '',
snoDes: '',
owes: 0
}
},
computed: {
...mapState({
studentSno: state => state.userInfo.sno,
flowId: state => state.flowInfo ? state.flowInfo.flowId : null,
parentRouter: state => state.currentProcedureInfo.parentRouter
})
},
created () {},
mounted () {
this.$vux.loading.show({
text: '加载中'
})
this.getBillList(0)
this.getHelperDes()
this.getThirdUrl()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},
toPay () {
window.location = this.thirdUrl + '?synjones_ticket=' + this.snoDes + '&synjones_type=app'

},





























getBillList (index) {
let params = {
studentSno: this.studentSno
}
return new Promise((resolve, reject) => {
this.$api.get('/charge', params,
r => {
this.$vux.loading.hide()
let data = r.data
this.pendingList = data.filter(function (item) {
return (item.owe > 0)
})
if (index === 0) {

this.billList = data
} else if (index === 1) {

this.billList = data.filter(function (item) {
return (item.owe > 0)
})
} else if (index === 2) {

this.billList = data.filter(function (item) {
return (item.owe <= 0)
})
}
this.owes = 0
data.forEach(element => {
if (element.owe > 0) {
this.owes ++
}
})
resolve()
},
err => {
console.log('charge' + err)
this.$vux.toast.text(err.message, 'top')
})
})
},
getThirdUrl () {
let params = {
flowId: this.flowId,
flowProcedureId: this.$route.query.flowProcedureId,
procedureId: this.$route.query.procedureId
}
this.$api.get('/flowProcedure', params,
r => {
this.thirdUrl = r.data[0].config

},
err => {
console.log(err)
})
},

getHelperDes () {
let params = {
info: this.studentSno
}
this.$api.get('/helper/des', params,
r => {
this.snoDes = encodeURIComponent(r.data)
},
err => {
console.log('获取HelperDes失败', err)

})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/pay.vue